import React from 'react';

interface Props {
  ges: string;
  shape?: 'square'|'rounded';
  size?: 'sm'|'md'|'lg';
}

function Ges({ ges, shape = 'square', size = 'sm' }: Props): React.JSX.Element {
  let gesColor: string;
  switch (ges) {
  case 'A':
    gesColor = 'bg-purple-100';
    break;
  case 'B':
    gesColor = 'bg-purple-200';
    break;
  case 'C':
    gesColor = 'bg-purple-300';
    break;
  case 'D':
    gesColor = 'text-white bg-purple-400';
    break;
  case 'E':
    gesColor = 'text-white bg-purple-500';
    break;
  case 'F':
    gesColor = 'text-white bg-purple-600';
    break;
  case 'G':
    gesColor = 'text-white bg-purple-700';
    break;
  default:
    gesColor = 'text-white bg-gray-500';
  }

  let shapeCSS = 'rounded-md';
  if (shape === 'rounded') {
    shapeCSS = 'rounded-full';
  }

  let sizeCSS = '';
  if (size === 'sm') {
    sizeCSS = 'w-6 h-6 text-xs flex items-center justify-center';
  } else if (size === 'md') {
    sizeCSS = 'w-8 h-8 text-sm flex items-center justify-center';
  } else if (size === 'lg') {
    sizeCSS = 'w-10 h-10 text-xl flex items-center justify-center';
  }

  // base Badge css
  const style = `inline-flex items-center justify-center bg-gray-50 font-medium shadow ${gesColor} ${shapeCSS} ${sizeCSS}`;

  return (
    <div className={style}>
      {ges}
    </div>
  );
}

export { Ges }; 